export const SEE_ARTICLE_LABEL = "Consulter l'article";
